const TerminosCondicionesClientes = () => {
  return (
    <div className="text-white/80">
      <p className="text-xs text-white/40 mb-6">
        <strong>Última actualización:</strong> 11 de febrero de 2026
      </p>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 mb-6">
        <strong className="text-blue-400 text-sm">ℹ️ ¿Qué es TiendasYA?</strong>
        <p className="text-sm mt-2">
          TiendasYA es una plataforma tecnológica que proporciona herramientas para que comerciantes 
          creen tiendas en línea. <strong>TiendasYA NO es el vendedor</strong> de los productos que encuentras aquí.
        </p>
      </div>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">1. Relación Comercial</h3>
        <p className="text-sm leading-relaxed mb-2">
          Cuando realizas una compra, el contrato es <strong>directamente entre tú y la tienda</strong>. 
          La tienda es responsable de todos los aspectos de la venta.
        </p>
        <p className="text-sm mb-2">La tienda es responsable de:</p>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Calidad y descripción de productos</li>
          <li>• Precios y disponibilidad</li>
          <li>• Procesamiento de pagos</li>
          <li>• Envío y entrega</li>
          <li>• Servicio al cliente</li>
          <li>• Devoluciones y reembolsos</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">2. Proceso de Compra</h3>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Revisa cuidadosamente tu pedido antes de confirmar</li>
          <li>• Verifica precios, cantidades y dirección de entrega</li>
          <li>• Guarda tu número de orden para seguimiento</li>
          <li>• Recibirás confirmación por correo electrónico</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">3. Métodos de Pago</h3>
        <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4">
          <strong className="text-amber-400 text-sm">⚠️ IMPORTANTE:</strong>
          <ul className="mt-2 space-y-1 text-sm">
            <li>• Los pagos se realizan <strong>directamente a la tienda</strong></li>
            <li>• TiendasYA NO procesa ni recibe pagos de clientes</li>
            <li>• Cada tienda define sus métodos de pago aceptados</li>
          </ul>
        </div>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">4. Entregas</h3>
        <p className="text-sm leading-relaxed mb-2">
          La tienda es responsable de la entrega de productos. Los tiempos de entrega son estimados 
          por cada tienda.
        </p>
        <p className="text-sm">
          Si hay problemas con tu entrega, contacta directamente a la tienda usando la información 
          proporcionada en tu confirmación de orden.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">5. Devoluciones y Reembolsos</h3>
        <p className="text-sm leading-relaxed mb-2">
          Cada tienda define su propia política de devoluciones. Revisa la política antes de comprar.
        </p>
        <p className="text-sm mb-2">Proceso de devolución:</p>
        <ol className="space-y-1 text-sm ml-4">
          <li>1. Contacta a la tienda para solicitar devolución</li>
          <li>2. Sigue las instrucciones de la tienda</li>
          <li>3. Los reembolsos son procesados por la tienda</li>
        </ol>
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 mt-3">
          <strong className="text-red-400 text-sm">TiendasYA NO:</strong>
          <ul className="mt-2 space-y-1 text-sm">
            <li>• Procesa reembolsos</li>
            <li>• Puede forzar a una tienda a aceptar devoluciones</li>
            <li>• Todas las disputas deben resolverse directamente con la tienda</li>
          </ul>
        </div>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">6. Protección de Datos</h3>
        <p className="text-sm leading-relaxed mb-2">
          Tu información se comparte con la tienda para procesar tu pedido. Cada tienda es responsable 
          de proteger tus datos.
        </p>
        <p className="text-sm mb-2">Información compartida:</p>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Nombre, dirección y contacto: Para entrega</li>
          <li>• Email: Para confirmaciones y seguimiento</li>
          <li>• No almacenamos información de pago</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">7. Limitación de Responsabilidad</h3>
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4">
          <strong className="text-red-400 text-sm">TiendasYA NO es responsable de:</strong>
          <ul className="mt-2 space-y-1 text-sm">
            <li>• Calidad, seguridad o legalidad de productos</li>
            <li>• Exactitud de descripciones de productos</li>
            <li>• Capacidad de las tiendas para completar ventas</li>
            <li>• Acciones u omisiones de las tiendas</li>
            <li>• Disputas entre clientes y tiendas</li>
            <li>• Pérdidas o daños derivados de compras</li>
          </ul>
        </div>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">8. Disputas y Reclamos</h3>
        <p className="text-sm leading-relaxed mb-2">
          Todos los reclamos deben dirigirse primero a la tienda usando la información de contacto 
          proporcionada en tu orden.
        </p>
        <p className="text-sm">
          TiendasYA puede facilitar comunicación entre partes, pero no estamos obligados a intervenir 
          en disputas ni podemos forzar resoluciones.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">9. Uso Aceptable</h3>
        <p className="text-sm mb-2">No puedes usar la plataforma para:</p>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Actividades fraudulentas o ilegales</li>
          <li>• Proporcionar información falsa</li>
          <li>• Abusar del sistema de devoluciones</li>
          <li>• Dañar la reputación de tiendas sin fundamento</li>
        </ul>
      </section>

      <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-4 mt-6">
        <strong className="text-emerald-400 text-sm">✅ Resumen Importante:</strong>
        <ul className="mt-2 space-y-1 text-sm">
          <li>• Compras directamente a la tienda, no a TiendasYA</li>
          <li>• La tienda es responsable de productos, pagos y entregas</li>
          <li>• TiendasYA solo proporciona la tecnología</li>
          <li>• Contacta a la tienda para cualquier problema con tu pedido</li>
          <li>• Guarda tu número de orden y datos de contacto de la tienda</li>
        </ul>
      </div>

      <p className="text-xs text-white/40 mt-6 text-center">
        Contacto: tiendasya.app@gmail.com | www.tiendasya.store
      </p>
    </div>
  );
};

export default TerminosCondicionesClientes;
